import { render, staticRenderFns } from "./LinkdeConviteEventIndex.vue?vue&type=template&id=a0fd294c&scoped=true"
import script from "./LinkdeConviteEventIndex.vue?vue&type=script&lang=js"
export * from "./LinkdeConviteEventIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fd294c",
  null
  
)

export default component.exports